import React from 'react'

import VideoPlayer from './video-player'

/**
 * Convert embeded Youtube Iframe to our own Video player component
 * Enable functionnalities such as Age Gating and Dynamic Ratings
 */
const EmbedVideo = (props) => {
  const globalData = props.globalData

  // Generate Embeded video informations
  const videoType = props.src.includes('youtube') ? 'youtube' : 'self'
  const videoURL = props.src.split('?') // Remove query parameters from video URL
  const videoUrlArray = videoURL[0].split('/')
  const videoID = videoUrlArray[videoUrlArray.length - 1] // Get last portion of the Youtube URL wich is the Video ID
  const posterImage = `${videoType === 'youtube' ? `https://img.youtube.com/vi/${videoID}/maxresdefault.jpg` : ''}`

  // Use Youtube embeded video start time buffer if available (ex.: ?start=2)
  let ratingTimeBuffer = props.ratingTimeBuffer ? props.ratingTimeBuffer : 0
  const videoQueryParams = videoURL[1]
  if (videoQueryParams) {
    const videoQueryParamsObj = videoQueryParams.split('&')
    videoQueryParamsObj.forEach((param) => {
      const pair = param.split('=')
      if (pair[0] == 'start') {
        // Multiply by 1000 to convert seconds in milliseconds
        ratingTimeBuffer = parseInt(pair[1] < 1000 ? pair[1] * 1000 : pair[1])
      }
    })
  }

  // Video Age Gate data
  const ageGateData = globalData.ageGateData ? globalData.ageGateData : false
  const stringsDates = globalData.stringsDates ? globalData.stringsDates : false
  const stringsErrors = globalData.stringsErrors ? globalData.stringsErrors : false

  return (
    <VideoPlayer
      id={videoID}
      pageContext={props.pageContext ? props.pageContext : null}
      className="video-embed"
      player={videoType}
      source={videoType === 'youtube' ? (videoID ? videoID : '') : null}
      poster={posterImage ? posterImage : ''}
      ratingTimeBuffer={ratingTimeBuffer}
      ageGateData={ageGateData}
      strings={{ errors: stringsErrors, dates: stringsDates }}
    />
  )
}

export default EmbedVideo
